import { NavLink } from "react-router-dom";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";

import "./styles.scss";

export function NavMenuItem(props) {
  return (
    <li className={props.className}>
      <NavLink
        className={cn(
          "tw:relative tw:flex tw:items-center tw:justify-center tw:gap-1",
          "tw:max-lg:flex-col tw:max-lg:text-xxs",
          "text-nowrap tw:fill-fill-white tw:text-text-white tw:no-underline",
          "tw:hover:fill-fill-teal-secondary tw:hover:text-text-teal-secondary",
          "tw:text-[15px] tw:transition-none",
          "tw:[.active]:fill-fill-teal-secondary tw:[.active]:text-text-teal-secondary",
        )}
        data-public="true"
        to={props.route}
        {...getAutomationDataAttr(props.testId)}
      >
        {props.children}
      </NavLink>
    </li>
  );
}
